import { i18n } from '../../i18n';
import type { ScreenConnectionCounts } from '../../lib/dashboard/screenStatus';

export type DisplaysHealthSummary = {
  totalLabel: string;
  locationLabel: string | null;
  /** Attention-first chips; falls back to online when the fleet is healthy. */
  highlights: string[];
};

/**
 * Compact companion summary for Displays — not a second filter UI.
 * Prefer problems (offline / unknown / unpaired); otherwise show online count.
 */
export function buildDisplaysHealthSummary(
  counts: ScreenConnectionCounts,
  locationCount: number,
): DisplaysHealthSummary {
  const totalLabel = i18n.t('displays:counts.displays', { count: counts.total });
  const locationLabel =
    locationCount > 0 ? i18n.t('displays:counts.locations', { count: locationCount }) : null;

  const highlights: string[] = [];
  if (counts.offline > 0) highlights.push(i18n.t('displays:counts.offline', { count: counts.offline }));
  if (counts.unknown > 0) highlights.push(i18n.t('displays:counts.unknown', { count: counts.unknown }));
  if (counts.unpaired > 0) {
    highlights.push(i18n.t('displays:counts.unpaired', { count: counts.unpaired }));
  }

  if (highlights.length === 0) {
    if (counts.online > 0) {
      highlights.push(i18n.t('displays:counts.online', { count: counts.online }));
    } else {
      highlights.push(i18n.t('displays:health.nonePaired'));
    }
  }

  return { totalLabel, locationLabel, highlights };
}
